<div class="product-rewards-root">
  <div
    class="product-rewards-list"
    infinite-scroll
    [infiniteScrollDistance]="0.1"
    [scrollWindow]="false"
    [immediateCheck]="true"
    (scrolled)="pullRewards()"
  >
    <div class="product-reward" *ngFor="let reward of rewards">
      <div class="reward">
        <img
          *ngIf="reward.imgSource"
          [src]="reward.imgSource"
          alt="rewardImg"
          (error)="handleImageError(reward)"
        />

        <div *ngIf="!reward.imgSource" class="default-img">
          <nb-icon icon="printer-outline"></nb-icon>
        </div>

        <div class="reward-details">
          <p class="reward-name">{{ reward.displayName }}</p>
          <p>
            {{ reward.displayDiscount }} -
            <strong>{{ reward.discount }}% off</strong>
          </p>
          <div class="reward-points">
            <span class="points">
              <mat-icon>stars</mat-icon>
              {{ reward.cost | number: '':language }}
            </span>
            <span class="exceptions"
              >{{ exceptionsLabel | transloco }} {{ reward.exceptions }}</span
            >
          </div>
        </div>
      </div>
      <app-reward-actions
        [reward]="reward"
        (editEvent)="goToRewardEdit(reward)"
        (deleteEvent)="deleteReward.emit(reward)"
      ></app-reward-actions>
    </div>
    <div *ngIf="loading" class="loading">
      <mat-spinner diameter="50"></mat-spinner>
    </div>
    <div>
      <mat-spinner diameter="15" *ngIf="pulling"></mat-spinner>
    </div>
  </div>
  <div class="add-reward">
    <app-icon-button
      icon="add_circle_outline"
      v2="true"
      (clickAction)="goToRewardEdit()"
    >
      {{ addRewardLabel | transloco }}</app-icon-button
    >
  </div>
</div>
